import React from 'react';
import { Shield, Clock, MapPin, ThumbsUp, Award, Heart } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Award,
      title: 'Newly Built Foxy Horsebox',
      description: 'Our 2025 horsebox is built to exceptional standards by Foxy Horseboxes'
    },
    {
      icon: Shield,
      title: 'Safe & Comfortable',
      description: 'State-of-the-art safety features ensuring your horse travels stress-free'
    },
    {
      icon: Clock,
      title: 'Flexible Hire Options',
      description: 'Half-day, full-day, and weekend packages to suit your needs'
    },
    {
      icon: MapPin,
      title: 'Convenient Location',
      description: 'Based between Harrogate and Boroughbridge in North Yorkshire'
    },
    {
      icon: ThumbsUp,
      title: 'Easy to Drive',
      description: 'Modern 3.5-ton Renault Master - no special license required'
    },
    {
      icon: Heart,
      title: 'Friendly Service',
      description: 'Dedicated to providing reliable and professional service'
    }
  ];

  return (
    <section id="about" className="py-20 lg:py-28 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 font-['Playfair_Display']">
            Why Choose <span className="text-[#2d5f3f]">Equi-Go</span>?
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Equi-Go is pleased to offer premium self-drive horsebox hire in the heart of North Yorkshire. 
            Whether you're heading to a competition, training session, vet visit, or pleasure ride, our 
            modern horsebox provides peace of mind and a smooth journey.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="group p-8 rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:border-[#2d5f3f]/30 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-14 h-14 rounded-xl bg-[#2d5f3f]/10 flex items-center justify-center mb-5 group-hover:bg-[#2d5f3f] group-hover:scale-110 transition-all duration-300">
                  <Icon className="w-7 h-7 text-[#2d5f3f] group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="bg-gradient-to-br from-[#2d5f3f] to-[#1e4029] rounded-3xl p-10 lg:p-12 text-white">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-4 font-['Playfair_Display']">
                Make an Enquiry
              </h3>
              <p className="text-white/90 text-lg leading-relaxed">
                We're happy to discuss your requirements and check availability. Get in touch 
                using email, phone, or complete our booking enquiry form.
              </p>
            </div>
            <div className="space-y-4">
              <div className="flex items-center space-x-4 bg-white/10 backdrop-blur-sm rounded-xl p-4 hover:bg-white/20 transition-colors duration-300">
                <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
                  <span className="text-2xl">📧</span>
                </div>
                <div>
                  <p className="text-sm text-white/70">Email</p>
                  <a href="mailto:enquiries@equi-go.co.uk" className="font-semibold hover:underline">
                    enquiries@equi-go.co.uk
                  </a>
                </div>
              </div>
              <div className="flex items-center space-x-4 bg-white/10 backdrop-blur-sm rounded-xl p-4 hover:bg-white/20 transition-colors duration-300">
                <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
                  <span className="text-2xl">📱</span>
                </div>
                <div>
                  <p className="text-sm text-white/70">Phone / WhatsApp</p>
                  <a href="tel:07788754165" className="font-semibold hover:underline">
                    07788 754165
                  </a>
                </div>
              </div>
              <button
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full flex items-center justify-center space-x-2 bg-white/10 backdrop-blur-sm rounded-xl p-4 hover:bg-white/20 transition-colors duration-300"
              >
                <span className="text-2xl">📝</span>
                <span className="font-semibold">Booking Enquiry Form</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;